<div class="agpr-mentionInsightCard agpr-contextMenu-parent">
    <div class="agpr-mentionInsightCard-nameContainer">
        <div class="agpr-mentionInsightCard-name">{{ insight.name }}</div>
        <div
            *ngIf="insight.isPreferred"
            class="agpr-mentionInsightCard-preferredIcon"
        >
            <span
                class="fa-solid fa-star"
                agprTooltip="Mentions.insightCard.preferred"
                tooltipPosition="top"
            ></span>
        </div>
    </div>
    <div [innerHTML]="(preContent + insight.content + afterContent) | setUlStyle | sanitizeHtml"></div>
    <div class="agpr-contextMenu bottom right">
        <agpr-button
            [style]="buttonTypes.contextMenu"
            [icon]="'fa-regular fa-pen fa-duotone'"
            tooltip="Mentions.insightCard.edit"
            tooltipPosition="bottom"
            (click)="editInsight()"
            class="agpr-mentionInsightCard-contextMenu-button"
        ></agpr-button>
        <agpr-button
            [style]="buttonTypes.contextMenu"
            [icon]="'fa-regular fa-duotone fa-trash-can'"
            tooltip="Mentions.insightCard.delete"
            tooltipPosition="bottom"
            (click)="deleteInsight()"
            class="agpr-mentionInsightCard-contextMenu-button"
        ></agpr-button>
    </div>

    <div class="agpr-contextMenu top right">
        <agpr-button
            *ngIf="!insight.isPreferred"
            [style]="buttonTypes.contextMenu"
            [icon]="'fa-regular fa-duotone fa-star'"
            (click)="setAsPreferred()"
            class="agpr-mentionInsightCard-contextMenu-button"
            tooltip="Mentions.insightCard.prefer"
            tooltipPosition="top"
        ></agpr-button>
    </div>
</div>
